import type { ComponentProps } from 'react';
import { useFormContext } from 'react-hook-form';
import type { ButtonVariant } from '@/components/UI/Button';
import FooterActionButton from './FooterActionButton';

type FormSaveButtonInfo = {
  text: string;
  action?: ButtonVariant;
  submittingText?: string;
};

export const FORM_SAVE_BUTTON_FOOTER_HEIGHT = 77;

export default function FormSaveButton({
  info,
  variant,
  isDisabled,
  disabled,
  ...props
}: {
  info: FormSaveButtonInfo;
  isDisabled?: boolean;
} & Omit<
  ComponentProps<typeof FooterActionButton>,
  'label' | 'loading' | 'loadingLabel'
>) {
  const form = useFormContext();
  const formState = form?.formState;

  return (
    <FooterActionButton
      testID="FormSaveButton"
      footerLayout="trailing"
      {...props}
      label={info.text}
      loadingLabel={info.submittingText}
      loading={formState?.isSubmitting ?? false}
      disabled={disabled ?? isDisabled ?? !formState?.isDirty}
      variant={variant ?? info.action ?? 'primary'}
    />
  );
}
